import RequestService from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import Report from '../types/Report';
import Result from '../types/Result';

const AdminReportsService = {
    getReports,
    getReport,
    getResults,
    getResult,
};

const createUrl = (params: {
    productType: number;
    projectId: number;
    jobMatch?: boolean;
    reportId?: number;
}) => {
    const { productType, projectId, jobMatch, reportId } = params;
    let url = `/admin/products/${productType}/projects/${projectId}/${!jobMatch ? 'reports' : 'job-matching-reports'}`;
    if (reportId) {
        url += `/${reportId}`;
    }
    return url;
};

const createResultsUrl = (params: {
    productType: number;
    projectId: number;
    reportId: number;
    resultId?: number;
    jobMatch?: boolean;
}) => {
    const { productType, projectId, jobMatch, resultId, reportId } = params;

    let url = `${createUrl({ productType, projectId, reportId, jobMatch })}/results`;
    if (resultId) {
        url += `/${resultId}`;
    }
    return url;
};

interface BasePayload {
    productType: number;
    projectId: number;
    jobMatch?: boolean;
}

async function getReports(
    payload: BasePayload & { limit?: number },
    thunkApi?: GetThunkAPI<any>,
) {
    const { productType, projectId, jobMatch, limit = 100 } = payload;
    try {
        return await RequestService.get<Report[]>(
            createUrl({ productType, projectId, jobMatch }),
            { limit },
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist reporty'),
        ); // TODO: translate

        throw e;
    }
}

interface ReportPayload extends BasePayload {
    reportId: number;
}

async function getReport(payload: ReportPayload, thunkApi?: GetThunkAPI<any>) {
    const { productType, projectId, reportId, jobMatch } = payload;
    try {
        return await RequestService.get<Report>(
            createUrl({ productType, projectId, reportId, jobMatch }),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist report'),
        ); // TODO: translate

        throw e;
    }
}

async function getResults(payload: ReportPayload, thunkApi?: GetThunkAPI<any>) {
    const { productType, projectId, reportId, jobMatch } = payload;
    try {
        return await RequestService.get<Result[]>(
            createResultsUrl({ productType, projectId, reportId, jobMatch }),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist vysledky'),
        ); // TODO: translate

        throw e;
    }
}

interface ResultPayload extends ReportPayload {
    resultId: number;
}

async function getResult(payload: ResultPayload, thunkApi?: GetThunkAPI<any>) {
    const { productType, projectId, reportId, resultId, jobMatch } = payload;
    try {
        return await RequestService.get<Result>(
            createResultsUrl({
                productType,
                projectId,
                reportId,
                resultId,
                jobMatch,
            }),
        );
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist vysledek'),
        ); // TODO: translate

        throw e;
    }
}

export default AdminReportsService;
